import { render, staticRenderFns } from "./videLinkeSelect.vue?vue&type=template&id=56b2b2bc&scoped=true"
import script from "./videLinkeSelect.vue?vue&type=script&lang=js"
export * from "./videLinkeSelect.vue?vue&type=script&lang=js"
import style0 from "./videLinkeSelect.vue?vue&type=style&index=0&id=56b2b2bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b2b2bc",
  null
  
)

export default component.exports